// Chakra imports
import {
  Flex,
  Grid,
  Image,
  SimpleGrid,
  useColorModeValue,
  useColorMode,
  Skeleton, SkeletonCircle, SkeletonText
} from "@chakra-ui/react";
// assets
// import peopleImage from "assets/img/people-image.png";
// import logoChakra from "assets/svg/logo-white.svg";
import BarChart from "components/Charts/BarChart";
import LineChart from "components/Charts/LineChart";
// Custom icons
import {
  CartIcon,
  DocumentIcon,
  GlobeIcon,
  WalletIcon,
} from "components/Icons/Icons.js";

import Card from "components/Card/Card";

import ApexCharts from "react-apexcharts";

import axios from "axios";


import React, { useEffect, useState } from "react";
import { dashboardTableData, timelineData } from "variables/general";
import UserStats from "./components/UserStats";
import Announcement from "./components/Announcement";
import MiniStatistics from "./components/MiniStatistics";
import GlobalStats from "./components/GlobalStats";
import LastArticle from "./components/LastArticle";
import {
  FaCalendar,
  FaClock,
  FaHouse,
  FaRoad,
} from "react-icons/fa6";
import { Global } from "@emotion/react";
import ChartBar from "./components/ChartBar";
import ChartLine from "./components/ChartLine";
import {toast} from "react-toastify"
import apiUrl from "variables/api";

export default function Dashboard() {
  const iconBoxInside = useColorModeValue("white", "white");

  const {colorMode} = useColorMode();
  const [chartUserData, setChartUserData] = useState({
    options: {
    chart: {
      toolbar: {
        show: false,
      },
    },
    tooltip: {
      style: {
        backgroundColor: "red",
        fontSize: "12px",
        fontFamily: undefined,
      },
      onDatasetHover: {
        style: {
          backgroundColor: "red",
          fontSize: "12px",
          fontFamily: undefined,
        },
      },
      theme: colorMode,
    },
    xaxis: {
      categories: ["-", "-", "-", "-", "-"],
      show: false,
      labels: {
        show: false,
        style: {
          colors: "#fff",
          fontSize: "12px",
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      show: true,
      color: "#fff",
      labels: {
        show: true,
        style: {
          colors: "#fff",
          fontSize: "14px",
        },
      },
    },
    grid: {
      show: false,
    },
    fill: {
      colors: "#fff",
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 8,
        columnWidth: "12px",
      },
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          plotOptions: {
            bar: {
              borderRadius: 0,
            },
          },
        },
      },
    ],
  },
  series: [{
    name: '-',
    data: [0, 0, 0, 0, 0]
}]
  });
  const [chartGlobalData, setChartGlobalData] = useState({
    options: {
    chart: {
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      selection: {
        enabled: false,
      }
    },
    tooltip: {
      theme: colorMode,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      categories: ["-", "-", "-", "-", "-"],
      labels: {
        show: false,
        style: {
          colors: "#c8cfca",
          fontSize: "12px",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: "#c8cfca",
          fontSize: "12px",
        },
      },
    },
    legend: {
      show: false,
    },
    grid: {
      strokeDashArray: 5,
    },
    colors: ["red", "hotpink", "purple", "green"],
  },
  series: [
    {name: '-', data: [0, 0, 0, 0, 0]},
  ]
  })
  const [userData, setUserData] = useState()
  const [globalStats, setGlobalStats] = useState()
  const [obnizka, setObnizka] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(apiUrl + '/data/userstats', {
          headers: {
            'x-access-token': localStorage.getItem('token'),
          },
        });
        const data = await response.json();

        setUserData(data)
        console.log(data)

        setChartUserData({
          options: {
          chart: {
            toolbar: {
              show: false,
            },
            zoom: {
              enabled: false,
            },
            selection: {
              enabled: false,
            }
          },
          tooltip: {
            style: {
              backgroundColor: "red",
              fontSize: "12px",
              fontFamily: undefined,
            },
            onDatasetHover: {
              style: {
                backgroundColor: "red",
                fontSize: "12px",
                fontFamily: undefined,
              },
            },
            theme: colorMode,
          },
          xaxis: {
            categories: [
              data.period.m4PeriodDate,
              data.period.m3PeriodDate,
              data.period.m2PeriodDate,
              data.period.m1PeriodDate,
              data.period.periodDate,
            ],
            show: false,
            labels: {
              show: false,
              style: {
                colors: "#fff",
                fontSize: "12px",
              },
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            show: true,
            color: "#fff",
            labels: {
              show: true,
              style: {
                colors: "#fff",
                fontSize: "14px",
              },
            },
          },
          grid: {
            show: false,
          },
          fill: {
            colors: "#fff",
          },
          dataLabels: {
            enabled: false,
          },
          plotOptions: {
            bar: {
              borderRadius: 8,
              columnWidth: "12px",
            },
          },
          responsive: [
            {
              breakpoint: 768,
              options: {
                plotOptions: {
                  bar: {
                    borderRadius: 0,
                  },
                },
              },
            },
          ],
        },
        series: [{
          name: localStorage.getItem('nickname'),
          data: data.userStats
      }]
        })
      } catch (error) {
        console.error('Error fetching data:', error);
        toast.error("Napotkano błąd podczas pobierania danych z API");
      }
    };

    fetchData();

  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(apiUrl + '/data/globalstats', {
          headers: {
            'x-access-token': localStorage.getItem('token'),
          },
        });
        const data = await response.json();
        console.log("cos", data)

        setGlobalStats(data)

        setChartGlobalData({
          options: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          tooltip: {
            theme: colorMode,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
          },

          
          xaxis: {
            categories: [
              data.period.m4PeriodDate,
              data.period.m3PeriodDate,
              data.period.m2PeriodDate,
              data.period.m1PeriodDate,
              data.period.periodDate,
            ],
            labels: {
              show: false,
              style: {
                colors: "#c8cfca",
                fontSize: "12px",
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: "#c8cfca",
                fontSize: "12px",
              },
            },
          },
          legend: {
            show: false,
          },
          grid: {
            strokeDashArray: 5,
          },
          colors: ["red", "hotpink", "purple", "green"],
        },
        series: [
          {name: 'Ogólne', data: data.global},
          {name: 'Zmiana 1', data: data.changeOne},
          {name: 'Zmiana 2', data: data.changeTwo},
          {name: 'SP', data: data.sp},
        ]
        })
      } catch (error) {
        console.error('Error fetching data:', error);
        toast.error("Napotkano błąd podczas pobierania danych z API");
      }
    };

    fetchData();

  }, []);

  const [normy, setNormy] = useState({});

  useEffect(() => {
    axios
    .get(apiUrl + "/data/minutes/normy", {
      headers: { "x-access-token": localStorage.getItem("token") },
    })
    .then((response) => {
      console.log(response.data);
      setNormy(response.data);
    })
    .catch((error) => {
      console.error(error);
      toast.error("Napotkano błąd podczas połączenia z API");
    });
  }, []);


  const calculateReduction = (liczbaWyjazdow) => {
    let roles = localStorage.getItem('roles')
    if (liczbaWyjazdow <= 20) return 0;
    let obnizka = Math.floor((liczbaWyjazdow - 20) / 20) * 50
    let plus = Number(getPlus(roles));
    let norma = Number(getNorma(roles));
    if(plus-obnizka < norma) {
       obnizka = plus - norma;
    }
    return obnizka;
  };

  const getNorma = (roles) => {

    const roleOrder = Object.keys(normy);
    let lastRole = 'podstawowa';
  
    for (const role of roleOrder) {
      if (roles.includes(role)) {
        lastRole = role;
      }
    }
    return normy[lastRole].split('/')[0];
  };

  const getPlus = (roles) => {
    const roleOrder = Object.keys(normy);
    let lastRole = 'podstawowa';
  
    for (const role of roleOrder) {
      if (roles.includes(role)) {
        lastRole = role;
      }
    }
  
    return normy[lastRole].split('/')[1];
  };

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} spacing="24px">
        <MiniStatistics
          title={"Liczba wyjazdów"}
          amount={userData?.userStats[4]}
          //percentage={32}
          icon={<FaRoad size={"20px"} color={iconBoxInside} />}
        />
        {obnizka ? (
                  <MiniStatistics
                  title={"Obniżka minut"}
                  subTitle={"Za poprzedni okres"}
                  amount={calculateReduction(userData?.userStats[3]) + " minut"}
                  icon={<FaClock size={"20px"} color={iconBoxInside} />}
                  onClick={() => setObnizka(false)}
                />
        ) : (
          <MiniStatistics
          title={"Liczba minut"}
          subTitle={"Poprzedni okres"}
          amount={userData?.userMinutes.userCurrentData?.liczba_minut_total ?? "Nie znaleziono"}
          percentage={
            userData?.userMinutes.userPreviousData?.liczba_minut_total
            && 
            userData?.userMinutes.userCurrentData?.liczba_minut_total 
            ?
            userData?.userMinutes.userCurrentData?.liczba_minut_total
            -
            userData?.userMinutes.userPreviousData?.liczba_minut_total
            : null}
          icon={<FaClock size={"20px"} color={iconBoxInside} />}
          onClick={() => setObnizka(true)}
        />
        )}
        <MiniStatistics
          title={"Obecny okres"}
          amount={userData?.period.periodDate || false}
          //percentage={0}
          icon={<FaCalendar size={"20px"} color={iconBoxInside} />}
        />
        <MiniStatistics
          title={"Obecna jednostka"}
          amount={
            userData?.userCurrentUnit == 3 ? "JRG SP" :
            userData?.userCurrentUnit == 2 ? "JRG 2" :
            userData?.userCurrentUnit == 1 ? "JRG 1" :
            userData ? "Brak przydzielonej jednostki" : null
          }
          change={userData?.userChange}
          icon={<FaHouse size={"20px"} color={iconBoxInside} />}
        />
      </SimpleGrid>
      <Grid
        templateColumns={{ sm: "1fr", lg: "1.3fr 1.7fr" }}
        templateRows={{ sm: "repeat(2, 1fr)", lg: "1fr" }}
        my="26px"
        gap="24px"
        mb={{ lg: "26px" }}
      >
        <UserStats
          title={"Statystyki użytkownika"}
          percentage={userData?.userStats[4] - userData?.userStats[3]}
          chart={<ChartBar data={chartUserData} />}
        />
        <GlobalStats
          title={"Statystyki ogólne"}
          percentage={globalStats?.global[4] - globalStats?.global[3]}
          chart={<ChartLine data={chartGlobalData} />}
        />
      </Grid>
      <Grid
        templateColumns={{ md: "1fr", lg: "1.8fr 1.2fr" }}
        templateRows={{ md: "1fr auto", lg: "1fr" }}
        gap="24px"
        mb={{ lg: "26px" }}
      >
        <Announcement/>
        <LastArticle />
      </Grid>
    </Flex>
  );
}